import React from 'react';
import { Container, Typography, Link, Box, List, ListItem, ListItemText, Divider } from '@mui/material';
import { styled } from '@mui/system';

// Define a new color palette for a refreshed design template
const primaryDark = '#1a202c'; // Dark background
const accentColor = '#667eea'; // A vibrant accent color (e.g., purple/blue)
const textColor = '#e2e8f0'; // Light text for contrast
const secondaryText = '#a0aec0'; // Slightly muted text

// Styled components for the new design template
const FooterRoot = styled('footer')(({ theme }) => ({
  backgroundColor: primaryDark,
  color: textColor,
  padding: theme.spacing(8, 0), // Generous vertical padding
  marginTop: 'auto',
}));

const FooterColumns = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: theme.spacing(4), // Consistent spacing between columns
  marginBottom: theme.spacing(6),
}));

const StyledColumnBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#2d3748',
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius * 2,
  flex: '1 1 200px', // Flexible columns with minimum width
  minWidth: '250px', // Minimum width before wrapping
  boxShadow: '0px 8px 15px rgba(0, 0, 0, 0.4)',
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-8px) scale(1.02)',
    boxShadow: '0px 15px 25px rgba(0, 0, 0, 0.6)',
    backgroundColor: '#3a475a',
  },
}));

const StyledLink = styled(Link)(({ theme }) => ({
  color: secondaryText,
  textDecoration: 'none',
  fontSize: '0.95rem',
  transition: 'color 0.2s ease-in-out',
  '&:hover': {
    color: accentColor,
    textDecoration: 'underline',
  },
}));

const Footer = () => {
  return (
    <FooterRoot id="contact">
      <Container maxWidth="lg">
        <FooterColumns>
          {/* Column 1: COPPER BOSS TECHNOLOGY */}
          <StyledColumnBox>
            <Typography variant="h6" gutterBottom sx={{ color: accentColor, fontWeight: 'bold' }}>
              COPPER BOSS TECHNOLOGY
            </Typography>
            <Typography variant="body2" sx={{ color: textColor, lineHeight: 1.6 }}>
              Building your digital dreams with <br />passion and precision.
              We believe in the power of <br />technology to make life easier,<br />
              smarter, and better.
            </Typography>
          </StyledColumnBox>

          {/* Column 2: Services */}
          <StyledColumnBox>
            <Typography variant="h6" gutterBottom sx={{ color: accentColor, fontWeight: 'bold' }}>
              Services
            </Typography>
            <List dense disablePadding>
              <ListItem disableGutters sx={{ py: 0.5 }}>
                <StyledLink href="#services">
                  <ListItemText primary="Software Development" />
                </StyledLink>
              </ListItem>
              <ListItem disableGutters sx={{ py: 0.5 }}>
                <StyledLink href="#services">
                  <ListItemText primary="Chip Level Service" />
                </StyledLink>
              </ListItem>
              <ListItem disableGutters sx={{ py: 0.5 }}>
                <StyledLink href="#services">
                  <ListItemText primary="PC Build" />
                </StyledLink>
              </ListItem>
              <ListItem disableGutters sx={{ py: 0.5 }}>
                <StyledLink href="#services">
                  <ListItemText primary="Training & Internship" />
                </StyledLink>
              </ListItem>
              <ListItem disableGutters sx={{ py: 0.5 }}>
                <StyledLink href="#services">
                  <ListItemText primary="Web & Digital Services" />
                </StyledLink>
              </ListItem>
            </List>
          </StyledColumnBox>

          {/* Column 3: Contact Us */}
          <StyledColumnBox>
            <Typography variant="h6" gutterBottom sx={{ color: accentColor, fontWeight: 'bold' }}>
              Contact Us
            </Typography>
            <List dense disablePadding>
              {/* <ListItem disableGutters sx={{ py: 0.5 }}>
                <ListItemText primary="Email: info@copperboss.com" sx={{ color: secondaryText }} />
              </ListItem> */}
              <ListItem disableGutters sx={{ py: 0.5 }}>
                <ListItemText primary="Phone: +91 8438555576" sx={{ color: secondaryText }} />
              </ListItem>
              <ListItem disableGutters sx={{ py: 0.5 }}>
                <ListItemText primary="Address: 2/885, V O C Nagar, Sulakkarai Medu, Virudhunagar." sx={{ color: secondaryText }} />
              </ListItem>
            </List>
          </StyledColumnBox>

          {/* Column 4: Map */}
          <StyledColumnBox>
            <Typography variant="h6" gutterBottom sx={{ color: accentColor, fontWeight: 'bold' }}>
              Our Location
            </Typography>
            <Box
              sx={{
                width: '100%',
                flexGrow: 1,
                overflow: 'hidden',
                borderRadius: '12px',
                mt: 2,
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3934.6396051685665!2d77.94173727353474!3d9.540006180783863!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b012d2bd5abc695%3A0x1d5d7f2c2642da92!2sCOPPER%20BOSS%20TECHNOLOGY!5e0!3m2!1sen!2sin!4v1749654074720!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Company Location"
              ></iframe>
            </Box>
          </StyledColumnBox>
        </FooterColumns>

        <Divider sx={{ my: 6, borderColor: '#4a5568' }} />

        {/* Copyright */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: secondaryText }}>
            © {new Date().getFullYear()} Copper Boss Technology. All Rights Reserved.
          </Typography>
        </Box>
      </Container>
    </FooterRoot>
  );
};

export default Footer;